<template>
    <div class="flex flex-col items-center justify-center w-full">
        <wide-card>
            <div class="mx-auto mb-24 sm mt-14">
                <svg
                    class="mx-auto mb-16"
                    xmlns="http://www.w3.org/2000/svg"
                    width="160"
                    height="160"
                    viewBox="0 0 279.998 279.999"
                >
                    <g transform="translate(-966 -230.001)">
                        <path
                            d="M45.162,138.169a33.191,33.191,0,0,1-.328-4.7,32.666,32.666,0,0,1,65.333.032v.048a4.63,4.63,0,0,0,4.617,4.62h18.876a4.507,4.507,0,0,0,4.507-4.507l0-37.492A9.333,9.333,0,0,1,153.1,88.7a13.889,13.889,0,0,0,8.749,2.79,14,14,0,0,0-.353-28,13.868,13.868,0,0,0-8.277,2.706,9.505,9.505,0,0,1-6.784,1.911,9.357,9.357,0,0,1-8.273-9.286V12.007A4.507,4.507,0,0,0,133.657,7.5H16.833A9.333,9.333,0,0,0,7.5,16.833V133.662a4.507,4.507,0,0,0,4.507,4.507H45.162Z"
                            transform="translate(958.5 222.501)"
                            fill="#31a265"
                        />
                        <path
                            d="M41.584,65.357V42.023a.442.442,0,0,1,.441-.441H65.359a4.225,4.225,0,0,0,0-8.451H42.026a8.9,8.9,0,0,0-8.892,8.892V65.357a4.225,4.225,0,1,0,8.45,0Z"
                            transform="translate(947.309 211.31)"
                            fill="#fcfcfc"
                        />
                        <path
                            d="M272.565,41.544a3.334,3.334,0,0,0,3.489,3.31q.587-.02,1.179-.02a32.667,32.667,0,0,1,.023,65.333q-.625,0-1.245-.022a3.361,3.361,0,0,0-3.445,3.38v20.136a4.507,4.507,0,0,0,4.507,4.507h37.268a9.557,9.557,0,0,1,7.612,3.629,9.34,9.34,0,0,1,.073,11.31,13.883,13.883,0,0,0-2.79,8.745,14,14,0,0,0,28-.351,13.871,13.871,0,0,0-2.705-8.275,9.511,9.511,0,0,1-1.91-6.786,9.357,9.357,0,0,1,9.285-8.271h46.823a4.507,4.507,0,0,0,4.507-4.507V16.833A9.334,9.334,0,0,0,393.9,7.5H277.072a4.507,4.507,0,0,0-4.507,4.507Z"
                            transform="translate(842.766 222.501)"
                            fill="#98b7d7"
                            opacity="0.3"
                        />
                        <path
                            d="M134.663,336.946a33.975,33.975,0,0,1-3.588-.067,32.668,32.668,0,0,1,2.424-65.246q.592,0,1.179.021a3.335,3.335,0,0,0,3.49-3.311v-20.2a4.507,4.507,0,0,0-4.507-4.507H96.388A9.554,9.554,0,0,1,88.776,240,9.338,9.338,0,0,1,88.7,228.7a13.885,13.885,0,0,0,2.791-8.742,14,14,0,0,0-28,.346,13.871,13.871,0,0,0,2.709,8.281,9.5,9.5,0,0,1,1.91,6.785,9.358,9.358,0,0,1-9.286,8.27H12.007A4.507,4.507,0,0,0,7.5,248.143V364.966a9.334,9.334,0,0,0,9.333,9.333H133.659a4.507,4.507,0,0,0,4.507-4.507V340.271a3.349,3.349,0,0,0-3.5-3.325Z"
                            transform="translate(958.5 135.7)"
                            fill="#98b7d7"
                            opacity="0.3"
                        />
                        <path
                            d="M336.943,276q.023.619.023,1.242a32.667,32.667,0,0,1-65.333-.01q0-.591.021-1.178a3.334,3.334,0,0,0-3.309-3.488h-20.2a4.507,4.507,0,0,0-4.507,4.507v37.492a9.34,9.34,0,0,1-7.052,9.054,9.7,9.7,0,0,1-8.066-1.724,13.846,13.846,0,0,0-7.7-2.654,14,14,0,1,0-.518,27.99,13.867,13.867,0,0,0,8.277-2.706,9.509,9.509,0,0,1,6.785-1.91,9.358,9.358,0,0,1,8.272,9.286v46.823a4.507,4.507,0,0,0,4.507,4.507H364.965A9.333,9.333,0,0,0,374.3,393.9V277.075a4.507,4.507,0,0,0-4.507-4.507h-29.48A3.349,3.349,0,0,0,336.943,276Z"
                            transform="translate(871.699 106.766)"
                            fill="#98b7d7"
                            opacity="0.3"
                        />
                        <g
                            transform="translate(1119.834 230.001)"
                            opacity="0.3"
                        >
                            <path
                                d="M477.891,7.5H464.933a9.333,9.333,0,0,1,9.333,9.333V133.66a4.507,4.507,0,0,1-4.507,4.507h12.958a4.507,4.507,0,0,0,4.507-4.507V16.833A9.333,9.333,0,0,0,477.891,7.5Z"
                                transform="translate(-361.06 -7.5)"
                                fill="#3b6490"
                            />
                            <path
                                d="M304.874,239.433h.005Z"
                                transform="translate(-280.558 -108.767)"
                                fill="#3b6490"
                            />
                        </g>
                        <path
                            d="M482.717,272.568H469.759a4.507,4.507,0,0,1,4.507,4.507V393.9a9.333,9.333,0,0,1-9.333,9.333h12.958a9.333,9.333,0,0,0,9.333-9.333V277.075A4.507,4.507,0,0,0,482.717,272.568Z"
                            transform="translate(758.773 106.766)"
                            fill="#3b6490"
                            opacity="0.3"
                        />
                        <path
                            d="M441.726,33.132H418.391a4.225,4.225,0,1,0,0,8.451h23.335a.442.442,0,0,1,.441.441V65.357a4.225,4.225,0,1,0,8.451,0V42.024A8.9,8.9,0,0,0,441.726,33.132Z"
                            transform="translate(780.939 211.31)"
                            fill="#fcfcfc"
                            opacity="0.3"
                        />
                        <path
                            d="M65.36,442.167H42.026a.442.442,0,0,1-.441-.442V418.392a4.225,4.225,0,0,0-8.451,0v23.333a8.9,8.9,0,0,0,8.892,8.892H65.36a4.225,4.225,0,1,0,0-8.451Z"
                            transform="translate(947.309 44.941)"
                            fill="#fcfcfc"
                            opacity="0.3"
                        />
                        <path
                            d="M441.726,33.132H418.391a4.225,4.225,0,1,0,0,8.451h23.335a.442.442,0,0,1,.441.441V65.357a4.225,4.225,0,1,0,8.451,0V42.024A8.9,8.9,0,0,0,441.726,33.132Z"
                            transform="translate(1264.688 45.275) rotate(90)"
                            fill="#fcfcfc"
                            opacity="0.3"
                        />
                    </g>
                </svg>

                <h1
                    class="mx-auto mb-12 text-2xl font-extrabold text-center text-blue-600"
                >
                    L'étape "Vous et votre projet" est terminée avec succès
                </h1>
                <p class="text-xl text-blue-400">
                  Merci de contacter le CRI-MS pour avoir plus d’information concernant l’étude de marché correspondante à votre secteur d’activité
                </p>
            </div>
        </wide-card>

        <base-primary-button title="Suivant" @click="nextStep" />
    </div>
</template>

<script>
import WideCard from "@/components/cards/wideCard";
//import succesMessage from "@/components/icons/succesMessage.vue";

export default {
    components: { WideCard },
    methods: {
        nextStep() {
            this.$store.dispatch(
                "forms/completeBigStep",
                "Vous et votre projet"
            );
            this.$router.push({
                name: "taille_et_evolution_du_marche",
                params: { uid: `${this.$store.state.user.bpiId}` }
            });
        }
    }
};
</script>
00
<style></style>
